/**
 * 共通ユーティリティ関数
 */

/**
 * 画像の読み込み完了を待ってコールバックを実行
 * @param {jQuery} $images - 画像要素のjQueryオブジェクト
 * @param {Function} callback - 読み込み完了時に実行するコールバック
 */
export function waitForImagesLoad($images, callback) {
  if ($images.length === 0) {
    callback();
    return;
  }

  let loadedCount = 0;
 const totalImages = $images.length;

  $images.each(function () {
    if (this.complete && this.naturalHeight !== 0) {
      loadedCount++;
    } else {
      this.addEventListener('load', function handleLoad() {
        loadedCount++;
        this.removeEventListener('load', handleLoad);
        if (loadedCount === totalImages) {
          callback();
        }
      });
    }
  });

  // すでに全て読み込み済みの場合
  if (loadedCount === totalImages) {
    callback();
  }
}

/**
 * スライドのprev/nextボタン位置を調整
 * @param {jQuery} $slide - スライド要素
 * @param {string} itemSelector - スライドアイテムのセレクター
 * @param {string} figureSelector - figure要素のセレクター
 * @param {Object} options - オプション
 * @param {boolean} options.useTransform - transformを使用するかどうか（デフォルト: false）
 */
export function adjustSlideButtonPosition($slide, itemSelector, figureSelector, options = {}) {
  const { useTransform = false } = options;
  const $item = $slide.find(itemSelector).first();

  if ($item.length > 0) {
    const $figure = $item.find(figureSelector);
    const figureHeight = $figure.length > 0 ? $figure.outerHeight() : 0;

    if (figureHeight > 0) {
      const buttonTop = figureHeight / 2;

      $slide.find('.slick-prev, .slick-next').each(function () {
        this.style.setProperty('top', buttonTop + 'px', 'important');
        if (useTransform) {
          // this.style.setProperty('transform', 'translateY(-50%)', 'important');
        } else {
          // this.style.setProperty('bottom', 'auto', 'important');
        }
      });
    }
  }
}

/**
 * デバウンス関数
 * @param {Function} func - 実行する関数
 * @param {number} wait - 待機時間（ミリ秒）
 * @returns {Function} デバウンスされた関数
 */
export function debounce(func, wait = 100) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
